import { Grid, Modal } from "@mui/material";
import React from "react";
import { globalColors } from "../../../../../../../../_metronic/_assets/sass/custom/globalColors";

export const PublicationModal = (props) => {
  const { open, handleClose, publication } = props;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: "80%",
          height: "80%",
          overflow: "auto",
          marginBottom: "5px",
          color: globalColors.textColor1
        }}
      >
        <button
          style={{
            position: "absolute",
            top: "10.5%",
            right: "11%",
            color: '#fff',
            fontSize: "30px",
            fontWeight: "bold",
            cursor: "pointer",
            backgroundColor: "transparent",
            border: "none",
          }}
          onClick={handleClose}
        >
          <span>x</span>
        </button>
        <Grid
          container
          spacing={3}
          style={{
            marginBottom: "5px",
            backgroundColor: globalColors.primaryColor2,
            color: "#fff",
            padding: "1em",
          }}
        >
          <Grid
            item
            sm={12}
          >
            <h2>{publication?.dailyName} - {new Date(publication?.publicationDate).toLocaleDateString()}</h2>
          </Grid>
          <Grid
            item
            sm={12}
            md={4}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p style={{fontWeight: 'bold'}}>Processo:</p>
            <p>{publication?.courtCaseNumber}</p>
          </Grid>
          <Grid
            item
            sm={12}
            md={4}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p style={{fontWeight: 'bold'}}>Vara:</p>
            <p>{publication?.court}</p>
          </Grid>
          <Grid
            item
            sm={12}
            md={4}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p style={{fontWeight: 'bold'}}>Comarca:</p>
            <p>{publication?.cityCounty}</p>
          </Grid>
        </Grid>
        <div style={{
          display: 'flex',
          height: 'calc(100% - 150px)',
          padding: '1em',
        }}>
          <div
            style={{
              width: '50%',
              height: '100%',
              borderRight: '1px solid #747474',
              paddingRight: '1.2em',
              overflow: 'auto',
              textAlign: 'justify',
              overflowX: 'hidden'
            }}
          >
            <h3>Texto original:</h3>
            <p>{publication?.originalText}</p>
          </div>
          <div
            style={{
              width: '50%',
              height: '100%',
              paddingLeft: '1.2em',
              overflow: 'auto',
              textAlign: 'justify',
              overflowX: 'hidden'
            }}
          >
            <h3>Texto simplificado:</h3>
            <p>{publication?.translatedText}</p>
          </div>
        </div>

      </div>
    </Modal>
  );
};
